import { render, staticRenderFns } from "./shader_mouse.vue?vue&type=template&id=88a02d56&scoped=true"
import script from "./shader_mouse.vue?vue&type=script&lang=js"
export * from "./shader_mouse.vue?vue&type=script&lang=js"
import style0 from "./shader_mouse.vue?vue&type=style&index=0&id=88a02d56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a02d56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88a02d56')) {
      api.createRecord('88a02d56', component.options)
    } else {
      api.reload('88a02d56', component.options)
    }
    module.hot.accept("./shader_mouse.vue?vue&type=template&id=88a02d56&scoped=true", function () {
      api.rerender('88a02d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shader/shader_mouse.vue"
export default component.exports